import React from 'react'
import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
import { Link } from 'react-router-dom'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import logoSvg from '@brainstud/react-tbl/themes/pgw/v1/assets/img/logo-schiphol.svg'
import logoBlackSvg from '@brainstud/react-tbl/themes/pgw/v1/assets/img/logo-schiphol-black.svg'
import './AppLogo.css'

const AppLogo = props => {
  const logo = (props.app.location && props.app.location.label === 'intro'
    || props.app.location && props.app.location.label === 'question')
    ? logoBlackSvg : logoSvg

  return (
    <div className="App-logo">
      <Link to={Routes.to('home')}><img src={logo} alt="Schiphol" /></Link>
    </div>
  )
}

export default withApp(AppLogo)
